<div #wrapper id="ush-showtimes-widget-wrapper">
  <ng-container *ngIf="!disableShowtimes">
    <div class="ush-showtimes-wrapper">
      <div class="ush-showtimes-header">
        <ush-location-selector
          #locationSelector
          (locationSelected)="handleLocationSelected($event)"
          [enableRouterNavigation]="enableRouterNavigation"
        ></ush-location-selector>

        <div *ngIf="!hasLocation" class="tab-msg ush-error-msg text">
          {{ 'public.commons.noLocation' | translate: { placeholder: 'There is no location selected' } }}
        </div>
        <!-- NEW SHOWTIME FLOW -->
        <div class="showtime-dates" *ngIf="showTimeDates && hasLocation && newFlowEnabled">
          <ush-showtime-dates
            [style.display]="previousPerformanceUiCount > 0 ? 'block' : 'none'"
            [dates]="showTimeDates"
            (dateSelected)="updateCinemaListOnDateChange($event)"
          ></ush-showtime-dates>
        </div>
      </div>
      <!-- NEW SHOWTIME FLOW -->
      <ng-container *ngIf="hasLocation && newFlowEnabled">
        <div class="ush-showtimes-loaded" *ngIf="!loadingShowtimes; else loading">
          <div
            *ngIf="performancesUi.length === 0"
            class="tab-msg ush-error-msg text"
            [innerHTML]="errorMsg() || '' | safe: 'html'"
            [attr.data-translate]="errorKey()"
          ></div>
          @if (performancesUi.length > 0 && isBrowser) {
            <div class="showtime-list" [@listAnimation]="performancesUi.length">
              @for (performance of performancesUi; track performance.cinema; let i = $index) {
                @if (i + 1 <= loadQtyAtOnce * loadMoreCtr) {
                  <div class="performance-wrapper" [id]="'cinema-wrapper-' + performance?.cinema?.id">
                    <ush-performance-header [performance]="performance" />
                    <ush-performance [date]="dateSelected" [perfGroup]="performance" newWorkflow hideAddress />
                  </div>
                }
              }
            </div>
          } @else {
            <div class="showtime-list" [style.min-height.px]="previousPerformanceUiCount * 145"></div>
          }
          <ush-load-more-cinemas (click)="loadMore()" *ngIf="!allCinemasForCurrentDateVisible"></ush-load-more-cinemas>

          <div class="ush-showtimes-nearestCities-wrapper" *ngIf="!diasbleNearestCities && nearestCities?.length > 0">
            <p
              class="ush-showtimes-nearestCities-title"
              [attr.data-translate]="'public.commons.nearestCities.availableAt'"
            >
              <span>{{
                'public.commons.nearestCities.availableAt' | translate: { placeholder: 'Showtimes also available at' }
              }}</span>
              <!-- <button class="ush-showtime-nearestCities-btn button" *ngIf="nearestCitySetted" (click)="restoreInitialPosition()">Restore</button> -->
            </p>
            <ul class="ush-showtimes-nearestCities-list">
              <li class="ush-showtimes-nearestCities-item" *ngFor="let city of nearestCities">
                <button class="ush-showtime-nearestCities-btn button" (click)="onNearCitySelected(city)">
                  {{ city.name }} ({{ city.formatDistance }})
                </button>
              </li>
            </ul>
          </div>
        </div>
      </ng-container>
      <!-- NEW SHOWTIME FLOW -->

      <!-- OLD SHOWTIME FLOW -->
      <ng-container *ngIf="hasLocation && !newFlowEnabled">
        <div class="ush-showtimes-loaded" *ngIf="!loadingShowtimes; else loading">
          <div
            *ngIf="performances.length === 0"
            class="tab-msg ush-error-msg text"
            [innerHTML]="errorMsg() | safe: 'html'"
            [attr.data-translate]="errorKey()"
          ></div>
          <p-accordion
            *ngIf="performances.length > 0"
            (onOpen)="onCinemaOpened($event)"
            (onClose)="onCinemaClosed()"
            [expandIcon]="null"
            [collapseIcon]="null"
            [styleClass]="'showtime-list'"
            [activeIndex]="indexPanelToOpen"
          >
            <ng-container *ngFor="let performance of performances; let i = index">
              <ng-container *ngIf="i + 1 <= loadQtyAtOnce * loadMoreCtr">
                <p-accordionTab #tab *ngIf="isBrowser" [@fadeInOut]>
                  <ng-template pTemplate="header">
                    <div class="showtime-cinema-wrapper old-flow" [ngClass]="{ active: i === currentIndex }">
                      <div class="showtime-cinema trigger ush-cinema" [ngClass]="{ active: i === currentIndex }">
                        <img
                          class="ush-cinema-logo"
                          [src]="performance.cinema.imageUrl | img: { placeholder: defaultCinemaPlaceholder }"
                          [alt]="performance.cinema.name"
                          (error)="handleCinemaErrorImg($event)"
                        />
                        <div class="ush-cinema-info">
                          <div class="showtime-text-info">
                            <span class="ush-cinema-name" [title]="performance?.cinema?.name">
                              <strong>{{ performance?.cinema?.name }}</strong>
                              @if (performance?.distanceLiteral) {
                                {{ ' (' + performance?.distanceLiteral + ')' }}
                              }
                            </span>
                          </div>
                          <span class="ush-cinema-address" [title]="performance.cinema.place.address">
                            <fa-icon [icon]="locationIcon" class="ush-cinema-address-marker"></fa-icon>
                            <span class="ush-cinema-address--place">{{ performance.cinema.place.address }}</span
                            >, <span class="ush-cinema-address--city">{{ performance.cinema.place.city.name }}</span>
                          </span>
                        </div>
                        <div class="ush-cinema-check-msg-wrap">
                          <div class="ush-cinema-check-msg">
                            <div class="ush-cinema-check-msg-inside">
                              <div class="ush-cinema-check-msg-chevron">
                                <fa-icon [icon]="chevronDownIcon" class="ush-cinema-check-msg-chevron-down"></fa-icon>
                                <fa-icon [icon]="chevronUpIcon" class="ush-cinema-check-msg-chevron-up"></fa-icon>
                              </div>
                              <span
                                class="ush-cinema-check-msg-message"
                                [attr.data-translate]="'public.commons.checkShowtimes'"
                              >
                                {{ 'public.commons.checkShowtimes' | translate: { placeholder: 'Check showtimes' } }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <ush-performance [perfGroup]="performance" />
                  </ng-template>
                </p-accordionTab>
              </ng-container>
            </ng-container>
          </p-accordion>

          <ush-load-more-cinemas (click)="loadMore()" *ngIf="!allItemsVisible"></ush-load-more-cinemas>

          <div class="ush-showtimes-nearestCities-wrapper" *ngIf="!diasbleNearestCities && nearestCities?.length > 0">
            <p
              class="ush-showtimes-nearestCities-title"
              [attr.data-translate]="'public.commons.nearestCities.availableAt'"
            >
              <span>{{
                'public.commons.nearestCities.availableAt' | translate: { placeholder: 'Showtimes also available at' }
              }}</span>
              <!-- <button class="ush-showtime-nearestCities-btn button" *ngIf="nearestCitySetted" (click)="restoreInitialPosition()">Restore</button> -->
            </p>
            <ul class="ush-showtimes-nearestCities-list">
              <li class="ush-showtimes-nearestCities-item" *ngFor="let city of nearestCities">
                <button class="ush-showtime-nearestCities-btn button" (click)="onNearCitySelected(city)">
                  {{ city.name }} ({{ city.formatDistance }})
                </button>
              </li>
            </ul>
          </div>
        </div>
      </ng-container>
      <!-- OLD SHOWTIME FLOW -->

      <!-- If there is extra description here put in a templateRef -->
      <!-- TODO: have the cineamo widget as a component to be used here, we will probably use it for more clients in the future -->
      @if (
        inCinemasAddon !== undefined &&
        loadingShowtimes === false &&
        hasMovieTwoYearsOld() === true &&
        (performances == undefined || performances.length === 0) &&
        (nearestCities == undefined || nearestCities.length === 0)
      ) {
        <ng-container
          [ngTemplateOutlet]="inCinemasAddon"
          [ngTemplateOutletContext]="{
            $implicit: newFlowEnabled ? performances.length === 0 : performancesUi.length === 0
          }"
        />
      }
    </div>
  </ng-container>
  <ng-container *ngIf="showUsheruLogo">
    <ush-usheru-logo></ush-usheru-logo>
  </ng-container>
</div>
<ng-template #loading>
  <div class="p-grid p-formgrid">
    <div class="p-field p-col-12 p-md-6">
      <p-skeleton height="4rem" styleClass="p-mb-2"></p-skeleton>
      <p-skeleton height="4rem" styleClass="p-mb-2"></p-skeleton>
      <p-skeleton height="4rem" styleClass="p-mb-2"></p-skeleton>
      <p-skeleton width="8rem" height="2rem" styleClass="p-mb-2 p-mx-auto"></p-skeleton>
      <p-skeleton width="15rem" height="2rem" styleClass="p-mb-2"></p-skeleton>
      <p-skeleton height="3rem" styleClass="p-mb-2"></p-skeleton>
      <p-skeleton width="8rem" height="3rem" styleClass="p-mb-2 "></p-skeleton>
    </div>
  </div>
</ng-template>
